import Vue from 'vue';

const listClass = 'v-autocomplete-list';
const listItemClass = 'v-autocomplete-list-item';
const activeClass = 'list-item-hover';

function changeDirection(direction = 'down', el) {
  const list = el.querySelector(`.${listClass}`); // Autocomplete is visible
  if (list) {
    list.classList.add('haskeyboardselect');
    const active = el.querySelector(`.${listItemClass}.${activeClass}`);
    if (active) {
      active.classList.remove(activeClass); // Remove active class from current element
      if (direction === 'down') {
        if (active.nextSibling) {
          active.nextSibling.classList.add(activeClass); // Add active to next
        } else {
          list.firstChild.classList.add(activeClass); // Add active to first
        }
      } else if (direction === 'up') {
        if (active.previousSibling) {
          active.previousSibling.classList.add(activeClass);
        } else {
          list.lastChild.classList.add(activeClass);
        }
      }
    } else {
      // Scrolled up to first or down to last element
      if (direction === 'down') {
        list.firstChild.classList.add(activeClass);
      }
      if (direction === 'up') {
        list.lastChild.classList.add(activeClass);
      }
    }

    const sel = el.querySelector(`.${listItemClass}.${activeClass}`);
    if (sel) {
      const elementBottom = sel.offsetHeight + sel.offsetTop;
      if (elementBottom > sel.parentElement.offsetHeight + sel.parentElement.scrollTop) {
        // Element is bottom is under visible box bottom
        const scrollTop = (sel.offsetTop - sel.parentElement.offsetHeight) + sel.offsetHeight;
        sel.parentElement.scrollTop = scrollTop;
      } else if (elementBottom < sel.offsetHeight + sel.parentElement.scrollTop) {
        // Element is bottom is above visible box scrollTop
        sel.parentElement.scrollTop = sel.offsetTop;
      }
    }
  }
}

function selectItem(el) {
  const active = el.querySelector(`.${listItemClass}.${activeClass}`);
  if (active) {
    active.click();
  }
}

Vue.directive('autocomplete-extend', {
  bind: (el) => {
    el.addEventListener('mouseover', e => {
      if (e.target && e.target.classList.contains(listItemClass)) {
        el.querySelector(`.${listClass}`).classList.remove('haskeyboardselect');
        [].forEach.call(el.querySelectorAll(`.${listItemClass}`), i => {
          i.classList.remove(activeClass);
        });
      }
    });

    el.addEventListener('keydown', (event) => {
      if (event.keyCode === 40) { // down
        changeDirection('down', el);
      } else if (event.keyCode === 38) {  // up
        changeDirection('up', el);
      } else if (event.keyCode === 13) {  // enter
        selectItem(el);
      }
    });
  },
});



// WEBPACK FOOTER //
// ./src/directives/autocomplete-extend.js